const isNormalizableWhitespace = (char: string) => {
  const code = char.charCodeAt(0);
  return (
    code <= 0x20 ||
    code === 0x00a0 ||
    code === 0x1680 ||
    (code >= 0x2000 && code <= 0x200a) ||
    code === 0x2028 ||
    code === 0x2029 ||
    code === 0x202f ||
    code === 0x205f ||
    code === 0x3000 ||
    code === 0xfeff
  );
};

export const normalizeText = (text: string) => {
  if (!text) {
    return text;
  }

  let result = "";
  let pendingWhitespace = false;

  for (const char of text.toString().normalize("NFD")) {
    if (isNormalizableWhitespace(char)) {
      pendingWhitespace = result.length > 0;
      continue;
    }

    if (pendingWhitespace) {
      result += " ";
      pendingWhitespace = false;
    }

    switch (char) {
      case "\u2018":
      case "\u2019":
        result += "'";
        break;
      case "\u201c":
      case "\u201d":
        result += '"';
        break;
      case "\u2013":
      case "\u2014":
        result += "-";
        break;
      default:
        result += char;
    }
  }

  return result;
};
